export {ContentQuoteCardSlider} from './lib/content-quote-card-slider';